/**
 * "1 document" / "2,340 documents": localized count + naive "s" plural.
 * Every count rendered in the clients feature goes through this so the
 * formatting can't drift between the stats strip, delete dialog, detail
 * header, and conversation rows.
 */
export const pluralCount = (n: number, word: string) =>
    `${n.toLocaleString()} ${word}${n === 1 ? "" : "s"}`;
